export default __webpack_public_path__ + "static/media/brahmaavtar_guruji.1c440d35.jpeg";